import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';

class CategoryCreate extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      name: ''
    };

    this.state = {
      ...this.initialState
    };
  }

  handleNameChange = (event, name) => this.setState({name, nameError: ''})

  validateName = () => {
    const {t} = this.props;
    if (!this.state.name) {
      this.setState({nameError: t('required')});
      return false;
    }
    return true;
  }

  handleClose = () => {
    this.setState(this.initialState);
    this.props.handleClose();
  }

  handleSave = () => {
    const {firebase} = this.props;

    const valid = [this.validateName].map((fn) => fn()).every(x => (x));
    if (!valid) return;

    var pushRef = firebase.database()
      .ref('portfolio/categories/')
      .push(this.state.name);

    this.setState(this.initialState);
    this.props.handleClose(pushRef.key);
  }
  render() {

    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('submit')}
        type="submit"
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    return (
      <Dialog
          title={t('createCategory')}
          open={this.props.open}
          onRequestClose={this.handleClose}
          actions={actions}
        >
          <TextField
            hintText={t('name')}
            floatingLabelText={t('name')}
            onBlur={this.validateName}
            errorText={this.state.nameError}
            onChange={this.handleNameChange}
            value={this.state.name}
            />
        </Dialog>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(CategoryCreate);



// WEBPACK FOOTER //
// ./src/Admin/CategoryCreate.js